<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        <span v-if="idsaldocliente != 0">
                            {{ $t('editar-limite-credito') }}
                        </span>
                        <span v-else>
                            {{ $t('adicionar-limite-credito') }}
                        </span>
                    </h1>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="fecharModal()">
                        {{ $t('cancelar') }}
                    </button>
                    <button class="save-btn" type="button" @click="save">
                        {{ $t('salvar') }}
                    </button>
                </div>
            </div>
            <br />
            <div class="columns form-columns-fit is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        :id="generateId(22)"
                        ref="idErpInput"
                        v-model="saldocliente.idsaldoclienteerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        required
                        tooltipLabel="cod-ref"
                        :invalid="!saldocliente.idsaldoclienteerp"
                        uppercase
                    />
                </div>

                <div class="column is-3">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaInput"
                        title="empresa"
                        :searchable="false"
                        :options="empresaSelect"
                        v-model="empresaSelected"
                        :invalid="isNull(empresaSelected)"
                        :required="true"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-empresa"
                        tooltipPosition="is-right"
                        :disabled="idsaldocliente != 0"
                    />
                </div>
                <div class="column is-3">
                    <v-money
                        :id="generateId(2)"
                        ref="creditoliberadoInput"
                        title="creditoliberado"
                        placeholder="placeholder-preencha"
                        v-model="saldocliente.creditoliberado"
                        :invalid="isNull(saldocliente.creditoliberado)"
                        :min="0"
                        :max="9999999"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        tooltipLabel="informacao-credito-liberado"
                        tooltipSize="is-large"
                        tooltipPosition="is-top"
                    />
                </div>
                <div class="column is-3">
                    <v-money
                        :id="generateId(3)"
                        ref="saldodevedorInput"
                        title="saldodevedor"
                        placeholder="placeholder-preencha"
                        v-model="saldocliente.saldodevedor"
                        :invalid="isNull(saldocliente.saldodevedor)"
                        :min="0"
                        :max="9999999"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        tooltipLabel="informacao-saldo-devedor"
                        tooltipSize="is-large"
                        tooltipPosition="is-left"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(4)"
                        ref="limitebonificacaoInput"
                        title="limitebonificacao"
                        placeholder="placeholder-preencha"
                        v-model="saldocliente.limitebonificacao"
                        :invalid="isNull(saldocliente.limitebonificacao)"
                        :min="0"
                        :max="9999999"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        tooltipLabel="informacao-limite-bonificacao"
                        tooltipSize="is-large"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(5)"
                        ref="LimiteBonificacaoPInput"
                        title="limitebonificacaop"
                        placeholder="placeholder-preencha"
                        v-model="saldocliente.limitebonificacaop"
                        :invalid="isNull(saldocliente.limitebonificacaop)"
                        :min="0"
                        :max="99"
                        :required="true"
                        tooltipLabel="informacao-limite-bonificacaop"
                        tooltipSize="is-large"
                        tooltipPosition="is-top"
                    />
                </div>
                <div class="column is-4">
                    <label for="situacao" v-text="$t('situacao')" />
                    <vss-select
                        :id="generateId(6)"
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        :invalid="isNull(situacaoSelected)"
                        msg="msg-campo-obrigatorio"
                        class="no-clear"
                        :mlLabels="true"
                        :disabled="idsaldocliente == 0"
                    />
                </div>
            </div>
            <br />
        </div>
    </div>
</template>

<script>
import LimiteCreditoClienteService from '@/services/vendas/cliente/abas/LimiteCreditoClienteService';
import Message from '@/models/Message';
import LimiteCreditoValidation from '@/services/validations/vendas/LimiteCreditoValidation';

/* @71021 */
export default {

    props: {
        idCliente: {
            type: Number,
            default: 0,
        },
        // Utilizado para obter os dados do limite de crédito selecionado
        idsaldocliente: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            serviceLimiteCredito: new LimiteCreditoClienteService(this.$http, this.$router),
            isLoading: false,
            validation: new LimiteCreditoValidation(this.msgs),
            msgs: [],
            saldocliente: {
                idsaldoclienteerp: null,
                idsaldocliente: null,
                idcliente: null,
                idempresa: null,
                nomeempresa: '',
                creditoliberado: 0,
                saldodevedor: 0,
                limitebonificacao: 0,
                limitebonificacaop: 0,
                situacao: null,
            },
            empresaSelect: [],
            empresaSelected: null,
            situacaoSelect: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacaoSelected: { label: 'ativo', id: 1 },

            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        if (this.idsaldocliente == 0) {
            this.carregarDadosEmpresa();
        } else {
            this.carregarDados();
        }
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'clientes',
            'ven-cliente-politica-comercial-limite-credito'
        );
        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'limite-credito' },
            });
        }
    },
    methods: {
        // Método para carregar no vss-select as empresaSelect que não estão listadas em LimiteCredito
        carregarDadosEmpresa() {
            this.findAllNaoAssociados()
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.idempresa,
                            label: i.nome,
                        };
                    });
                })
                .then((value) => {
                    this.empresaSelect = value;
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        findAllNaoAssociados() {
            if (this.isVenda)
                return this.serviceLimiteCredito.findAllNaoAssociadosVendas(this.idCliente);
            else return this.serviceLimiteCredito.findAllNaoAssociadosAgro(this.idCliente);
        },
        // Método para carregar os dados do limite de crédito selecionado para edição
        carregarDados() {
            this.serviceLimiteCredito
                .find(this.idsaldocliente)
                .then((value) => {
                    this.saldocliente = Object.assign({}, value.content);
                    this.empresaSelected = {
                        id: this.saldocliente.idempresa,
                        label: this.saldocliente.nomeempresa,
                    };
                })
                .then(this.mapItems)
                .catch((e) => {
                    console.error(e);
                });
        },

        generateId(numberId) {
            return this.$route.name + '-saldocliente-' + numberId;
        },
        save() {
            this.isLoading = true;
            this.saldocliente.idcliente = this.idCliente;
            this.saldocliente.situacao = this.situacaoSelected.id;
            this.saldocliente.idempresa =
                this.empresaSelected != null ? this.empresaSelected.id : null;
            if (this.validation.validate(this.saldocliente, this.$refs)) {
                this.saveLC()
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message(value.status === 409 ? 'alert' : 'error', `${value.message}`, true));
                        } else {
                            this.$root.showMessage(
                                'success',
                                this.saldocliente.idsaldocliente != null
                                    ? 'msg-sucesso-ao-editar-associcao'
                                    : 'msg-sucesso-ao-adicionar-associacao'
                            );
                            setTimeout(() => {
                                this.$emit('fecharModal', true);
                            }, 200);
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        saveLC() {
            if (this.isVenda) return this.serviceLimiteCredito.saveVendas(this.saldocliente);
            else return this.serviceLimiteCredito.saveAgro(this.saldocliente);
        },
        fecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
